import React from "react";
import Sortable, { ISortableOptions } from "devextreme-react/sortable";

interface IMdaeKanban extends ISortableOptions {}

const MdaeKanban: React.FC<IMdaeKanban> = (props) => {
  return <Sortable {...props}>{props.children}</Sortable>;
};
export default MdaeKanban;
